<template>
  <div class="detail">
    <div class="header">
      <div class="left" @click="toIndex()">< 返回</div>
      <div v-if="!info.org_id " class="span1"><span>查看详情</span></div>
      <div class="right"></div>
    </div>
    <div class="main">
      <div v-if="info.org_id ">
        <!-- <div class="main-li">
          <p>机构名称 </p>
          <span> {{ info.org_name || "无" }} </span>
        </div>
        <div class="main-li">
          <p>机构地址</p>
          <span> {{ info.org_address || "无" }} </span>
        </div>
        <div class="main-li">
          <p>法人姓名</p>
          <span> {{ info.school_legal_person_name || "无" }} </span>
        </div>
        <div class="main-li">
          <p>联系电话</p>
          <span> {{ info.org_telephone || "无" }} </span>
        </div>
        <div class="main-li">
          <p>执照代码</p>
          <span> {{ info.org_social_credit_code || "无" }} </span>
        </div> -->
        <Information :info="info" ></Information>
      </div>
      <div v-else>
        <div class="main-li">
          <p>管理员姓名</p>
          <span> {{ info.name || "无" }} </span>
        </div>
        <div class="main-li">
          <p>性别</p>
          <span> {{ gender| genderFilter }} </span>
        </div>
        <div class="main-li">
          <p>账号</p>
          <span> {{ info.account || "无" }} </span>
        </div>
        <div class="main-li">
          <p>证件类型</p>
          <span> {{ card_type | cardTypeFilter }} </span>
        </div>
        <div class="main-li">
          <p>证件编号</p>
          <span> {{ card_code || "无" }} </span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { getUserInfo ,getMemberInfo} from "@/api/user/userCenter";
export default {
  props: ["info"],
  components: {
     Information: () => import("./information.vue")
  },
  data() {
    return {
      card_code: "",
      gender:"2",
      card_type:"",
    };
  },
  computed: {},
  watch: {
	 "info.user_id": function (n, o) {
      this.getDataList(n);
    },
  },
  created() {},
  filters: {
    statusFilter(type) {
      const typeMap = {
        0: "未激活   ",
        1: "正常    ",
        2: "注销    ",
        3: "锁定    ",
        4: "安管锁定",
        5: "空间封锁",
      };
      return typeMap[type] || '无';
    },
    genderFilter(type) {
      const typeMap = {
        0: "女",
        1: "男",
        2: "保密",
      };
      return typeMap[type] || '无';
    },
    cardTypeFilter(type) {
      const typeMap = {
        0: "身份证",
        1: "护照",
        2: "驾照",
      };
      return typeMap[type] || '无';
    },
  },
  methods: {
    async getDataList(userId) {
      // let params = {
      //   user_id: userId, //机构、学校等组织id
      // }
      // const { code, result } = await getUserInfo(params);
      // console.log('获取用户信息--get',code, result);
      // if (code == "000000") {
		  //  this.card_code= result.card_code
      //  this.card_type= result.card_type 
      //  this.gender=result.gender
      // }
       let paramsData = {
        user_id:JSON.parse(window.sessionStorage.getItem("Userlist")).userId,
        top_org_id:sessionStorage.getItem("orgId")
      };
      getMemberInfo(paramsData).then(res=>{
          console.log('用户中心获取用户信息----',res);
         if(res.code == "000000"){
             this.card_type=res.result.card_type
             this.card_code=res.result.card_code
             this.gender=res.result.gender
         } 
      })
    },
    toIndex() {
      this.$emit("to-index");
    },
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
.detail {
  width: 100%;
  padding: 0px 30px 30px 30px;
  .header {
    height: 60px;
    line-height: 48px;
    margin-bottom: 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .span1 {
      font-family: "PingFang SC Bold";
      font-size: 20px;
      color: #000;
      margin-right: 30px;
    }
    .left,
    .right {
      width: 60px;
    }
    .left {
      cursor: pointer;
    }
  }
  .main {
    width: 100%;
    height: 100%;
    .main-title {
      display: flex;
      align-items: center;
      p {
        font-weight: bold;
        font-size: 14px;
        color: #181c26;
        margin-left: 10px;
      }
    }
    .main-li {
      margin-top: 20px;
      width: 100%;
      display: flex;
      // align-items: center;
      font-size: 14px;
      color: #888;
      p {
        width: 120px;
        text-align: right;
        margin-right: 20px;
      }
      span {
        width: calc(100% - 150px);
        word-wrap:break-word;
      }
    }
  }
}
footer {
  margin-top: 50px;
  display: flex;
  justify-content: center;
}
</style>
